import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

import loginReducer from "./features/loginSlice";
import settingReducer from "./features/settingSlice";
import dashboardReducer from "./features/dashboardSlice";
import globalReducer from "./features/globalSlice";
import modalReducer from "./features/modalSlice";
import employeesReducer from "./features/employeeSlice";
import paymentHistoryReducer from "./features/paymentSlice";
import exportHistoryReducer from "./features/exportHistorySlice";

export const store = configureStore({
  reducer: {
    login: loginReducer,
    setting: settingReducer,
    dashboard: dashboardReducer,
    global: globalReducer,
    modal: modalReducer,
    employees: employeesReducer,
    paymentHistory: paymentHistoryReducer,
    exportHistory: exportHistoryReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
export const useAppDispatch = () => useDispatch<AppDispatch>();
